<template>
  <CardContainer>
    <template v-slot:title>
      {{ text.pages.cart.chooseDeliveryType }}
    </template>
    <template v-slot:content>
      <v-container fluid>
        <v-row align="center">
          <v-col class="d-flex" cols="12" sm="6">
            <v-select
              v-model="delivery"
              :items="deliveryTypes"
              item-value="id"
              item-text="name"
              dense
              @change="setPrice"
              :disabled="currentStep > viewStep"
            ></v-select>
          </v-col>
        </v-row>
      </v-container>
    </template>
    <template v-slot:action>
      <CartActionButtons :current-step="currentStep" :view-step="viewStep"
                         v-on:back="$emit('back')"
                         v-on:confirm="$emit('confirm');
                         $store.commit('updateOrderData', {delivery: delivery})"
                         :hideConfirm="hideConfirm"
      />
    </template>
  </CardContainer>
</template>

<script>
import { translations } from '@/lang/translations';
import Axios from '@/core/Axios';
import CardContainer from '@/components/Partials/CardContainer.vue';
import CartActionButtons from '@/components/Pages/CartActionButtons.vue';
import { state } from '../../store/index';

export default {
  name: 'CartDelivery',
  components: { CardContainer, CartActionButtons },
  props: ['currentStep'],
  data() {
    return {
      delivery: null,
      deliveryTypes: [],
      axios: new Axios(),
      viewStep: 2,
      fullDeliveryTypes: [],
      hideConfirm: true,
    };
  },
  mounted() {
    this.getDeliveryTypes();
  },
  computed: {
    text() {
      return translations[state.language];
    },
  },
  methods: {
    getDeliveryTypes() {
      this.axios
        .makeCall('GET', 'norbit/delivery')
        .then((response) => {
          if (response) {
            this.fullDeliveryTypes = response;
            this.deliveryTypes = response.map((value) => ({
              id: value.id,
              name: `${value.name}, ${value.price_gross.toFixed(2)} ${this.text.common.currency}`,
            }));
          }
        })
        .catch(() => {
          this.$store.commit('showSnackbar', {
            type: 'error',
            message:
            this.text.messages.loadDataError,
          });
        });
    },
    setPrice(e) {
      this.hideConfirm = false;
      const selectedDeliveryType = this.fullDeliveryTypes.filter((v) => v.id === e);
      this.$emit('setDeliveryPrice', selectedDeliveryType[0]);
    },
  },
};
</script>

<style scoped>

</style>
